<template>
  <div>
    <h2 class="content-block">Show Images In Vue</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        Put your content here
        <div>
          <img :src="imageUrl" alt="My Image" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      imageUrl: "",
    };
  },
  mounted() {
    axios.get("/image-url").then((response) => {
      this.imageUrl = response.data.url;
    });
  },
};
</script>
<style lang="scss"></style>
